import React, { useMemo } from 'react';
import {
    UpcomingPeriodKey,
    useDashboard,
} from '../../../../contexts/DashboardContext';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import useTranslate from '../../../../customHooks/useTranslate';
import { MenuItem, Select } from '@mui/material';
import useLanguage from '../../../../customHooks/useLanguage';
import UpcomingCheckInsItem from './UpcomingCheckInsItem';
import { formatUpcomingPeriodSubtitle } from '../../../../utils/dashboard/dashbordUtils';
import { capitalize } from '../../../../utils/usefulFunctions';
import { Link } from 'react-router-dom';
import routes from '../../../../utils/commonVariables/routes';

const UpcomingCheckInsList = () => {
    const { upcomingBookings, changeUpcomingBookingsPeriod } = useDashboard();
    const translate = useTranslate();
    const language = useLanguage();
    const title = translate('upcoming_checkins');

    const periodSubtitle = useMemo(() => {
        const subtitle = formatUpcomingPeriodSubtitle(
            upcomingBookings.period.key,
            language
        );
        return capitalize(subtitle);
    }, [upcomingBookings.period.key, language, translate]);

    return (
        <>
            <div className='flex flex-align-center flex-between'>
                <div className='flex-column gap-5'>
                    <SectionTitle title={title} variant='h3' />
                    <p className='landing-chart__subtitle'>{periodSubtitle}</p>
                </div>
                <Select
                    size='small'
                    className='landing-chart__period-select'
                    value={upcomingBookings.period.key}
                    onChange={e =>
                        changeUpcomingBookingsPeriod(
                            e.target.value as UpcomingPeriodKey
                        )
                    }
                >
                    {Object.entries(UpcomingPeriodKey).map(([key, value]) => (
                        <MenuItem
                            key={key}
                            value={
                                UpcomingPeriodKey[
                                    key as keyof typeof UpcomingPeriodKey
                                ]
                            }
                        >
                            {translate(value)}
                        </MenuItem>
                    ))}
                </Select>
            </div>

            {upcomingBookings.isLoading ? (
                <LoadingPlaceholder
                    variant='rounded'
                    width={'100%'}
                    height={'100%'}
                />
            ) : upcomingBookings.isDataLoaded &&
              upcomingBookings.data.length ? (
                <div className='flex-column flex-grow overflow-hidden'>
                    <ul className='next-bookings__list'>
                        {upcomingBookings.data.map((booking, index) => (
                            <UpcomingCheckInsItem
                                key={index}
                                booking={booking}
                            />
                        ))}
                    </ul>
                    <div className='padding-top-20 '>
                        <Link
                            to={routes.landingPrivate + routes.booking}
                            className='font-weight-500'
                            style={{ color: 'var(--secondary-600)' }}
                        >
                            {translate('view_all_bookings')}
                        </Link>
                    </div>
                </div>
            ) : (
                <div className='height100perc flex-center-center text-size-16 font-weight-500'>
                    {translate('no_upcoming_check_ins')}
                </div>
            )}
        </>
    );
};

export default UpcomingCheckInsList;
